import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "Email", value: "mmrinmoy90@gmail.com", href: "mailto:mmrinmoy90@gmail.com", id: "contact-email-link", external: false },
  { label: "LinkedIn", value: "in/mrin7", href: "https://www.linkedin.com/in/mrin7", id: "contact-linkedin-link", external: true },
  { label: "Resume", value: "Download PDF", href: "https://customer-assets.emergentagent.com/job_portfolio-showcase-2863/artifacts/sy01uftu_MM.Resume.pdf", id: "contact-resume-link", external: true },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative border-t border-black/10 bg-[#0A0A0A] text-[#F4F4F2]"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <div className="font-mono-mini text-[#8A8A8A]">§ 04</div>
            <div className="font-mono-mini mt-1">Contact</div>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <p className="text-base md:text-lg leading-relaxed max-w-md text-[#F4F4F2]/80">
              Currently designing at Nunify and open to thoughtful
              collaborations. The fastest way to reach me is email. I read
              every line.
            </p>
          </div>
        </div>

        {/* Massive type punch */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
          className="font-display tracking-tighter leading-[0.85] text-[18vw] md:text-[14vw] text-[#F4F4F2] mb-16 md:mb-24"
        >
          <a
            href="mailto:mmrinmoy90@gmail.com"
            data-testid="contact-cta-email"
            className="inline-flex items-baseline gap-4 md:gap-6 group text-[#F4F4F2]"
          >
            <span className="block">Let’s</span>
            <span
              className="italic font-light"
              style={{ fontFamily: "'Cabinet Grotesk', serif" }}
            >
              talk.
            </span>
            <ArrowUpRight
              className="ml-2 md:ml-4 text-[#FF3B30] transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
              size={56}
              strokeWidth={1.5}
            />
          </a>
        </motion.div>

        {/* Link grid */}
        <div className="grid grid-cols-12 gap-6 md:gap-12 border-t border-white/15 pt-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={l.id}
              target={l.external ? "_blank" : undefined}
              rel="noreferrer"
              className="col-span-6 md:col-span-3 group block"
            >
              <div className="font-mono-mini text-[#8A8A8A]">{l.label}</div>
              <div className="mt-2 text-lg md:text-2xl font-display tracking-tighter text-[#F4F4F2] flex items-center gap-2">
                <span className="link-underline break-all">{l.value}</span>
                <ArrowUpRight
                  size={18}
                  className="opacity-60 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 shrink-0"
                />
              </div>
            </a>
          ))}
        </div>

        {/* Footer line */}
        <div className="mt-20 md:mt-28 flex flex-col md:flex-row md:items-end md:justify-between gap-6 font-mono-mini text-[#8A8A8A]">
          <div>
            <div>India · UI / UX Practice</div>
            <div className="mt-1">Open to opportunities</div>
          </div>
          <div className="text-right md:text-right">
            <div>© 2026 Mrinmoy Mondal</div>
            <div className="mt-1">Set in Cabinet Grotesk &amp; Satoshi</div>
          </div>
        </div>
      </div>
    </section>
  );
};
